import type { ProjectPlanSliceState } from '.';

import { PLAN_NAME } from '@readme/plans';

/**
 * Our initial `ProjectPlanSlice` state. On the Hub, this state is immediately
 * overridden by SSR props and replaced before any components connect to it.
 * This initial state simply provides us with some starting data during testing
 * and when running Styleguidist.
 */
const initialState: ProjectPlanSliceState = {
  activePlan: PLAN_NAME.FREE,
  isTrial: true,
  isTrialExpired: false,
  plan: PLAN_NAME.FREE,
  details: {
    cost: 0,
    createdAt: new Date('November 10, 2022 03:24:00'),
    endDate: new Date('November 10, 2022 03:24:00'),
    is_active: false,
    legacy: false,
    members: 0,
    name: '',
  },
  features: {
    admins: false,
    ai_agent: false,
    ai_writer: false,
    api_access: true,
    askai: false,
    branch_approval: false,
    branches: false,
    changelogs: false,
    custom_domain: false,
    custom_pages: false,
    custom_components: false,
    discussions: false,
    doc_metrics: true,
    docs_audit: false,
    errors: false,
    extra_html: false,
    glossary: false,
    guides: false,
    healthCheck: false,
    html: false,
    javascript: false,
    jwt: true,
    landing_page: false,
    metricsExports: false,
    password: false,
    pdf: false,
    recipes: false,
    reference: true,
    reusableContent: false,
    stylesheet: false,
    usability: false,
    user_analytics: false,
    variables: false,
    versions: 3,
    whitelabel: false,
  },
  override: undefined,
};

export default initialState;
